import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function promoCodeDataReducer(
  state = initialState.promoCodeData,
  action
) {
  switch (action.type) {
    case types.LOADED_PROMO_CODE_DATA_SUCCESS:
      return action.promoCodeData;
    default:
      return state;
  }
}
